<header [preLogin]="false"></header>
<div class="pre-login">
    <div class="post-login-1-col-1 h-100">
        <app-left-panel-prelogin activeTab="3"></app-left-panel-prelogin>
    </div>
    <div class="post-login-1-col-2 h-100 p-mobile-15">
            <grid-row class="justify-content-center align-content-center h-100vh-101 align-content-start-on-sm">
                <grid-col col="4" mobile="12">
                    <div class="mt-30">
                        <div class="bg-base-100 p-16 box-shadow br-16 mt-16 mb-16 link" (click)="branchLocator()">
                            <grid-row class="col-space-min align-item-center">
                                <grid-col col="auto">
                                    <ng-icon iconClass="icon-BCFC-branches v-align-middle text-align-left" width="29"
                                        height="29"></ng-icon>
                                </grid-col>
                                <grid-col col="8">
                                    <span class="font-size-14px font-600 color-base-700 line-h-18">
                                        {{ "BCFCBranches" | translate }}</span>
                                </grid-col>
                            </grid-row>
                        </div>
                    </div>
                    <div class="mt-30">
                        <div class="bg-base-100 p-16 box-shadow br-16 mt-16 mb-16 link" (click)="showModal(1)">
                            <grid-row class="col-space-min align-item-center">
                                <grid-col col="auto">
                                    <ng-icon iconClass="icon-skip-queue v-align-middle text-align-left" width="29"
                                        height="29"></ng-icon>
                                </grid-col>
                                <grid-col col="8" mobile="auto">
                                    <span class="font-size-14px font-600 color-base-400 line-h-18">
                                        {{ "SkipTheQueue" | translate }}</span>
                                </grid-col>
                            </grid-row>
                        </div>
                    </div>

                    <div class="mt-30">
                        <div class="bg-base-100 p-16 box-shadow br-16 mt-16 mb-16 link" (click)="feedbacks()">
                            <grid-row class="col-space-min align-item-center">
                                <grid-col col="auto">
                                    <ng-icon iconClass="icon-feedback-complaints v-align-middle text-align-left"
                                        width="29" height="29"></ng-icon>
                                </grid-col>
                                <grid-col col="8">
                                    <span class="font-size-14px font-600 color-base-700 line-h-18">
                                        {{ "Complaints" | translate }}</span>
                                </grid-col>
                            </grid-row>
                        </div>
                    </div>

                    <div class="mt-30">
                        <a style="text-decoration: none; cursor: pointer;" href="tel:{{this.Phone}} auto-dial">
                            <div class="bg-base-100 p-16 box-shadow br-16 mt-16 mb-16 link" (click)="click()">
                                <grid-row class="col-space-min align-item-center">
                                    <grid-col col="auto">
                                        <ng-icon iconClass="icon-phone-call v-align-middle text-align-left" width="29"
                                            height="29"></ng-icon>
                                    </grid-col>
                                    <grid-col col="8">
                                        <span class="font-size-14px font-600 color-base-700 line-h-18"
                                            *ngIf="this.call == false">
                                            {{ "PhoneCall" | translate }}</span>
                                        <span class="font-size-14px font-600 color-base-700 line-h-18"
                                            *ngIf="this.call == true">
                                            {{ "PhoneCall" | translate }}: {{this.Phone}}</span>

                                    </grid-col>
                                </grid-row>
                            </div>
                        </a>
                    </div>
                 
                    <div class="mt-30">
                        <a style="text-decoration: none; cursor: pointer;" (click)="emailUs()">
                            <!-- href="mailto:{{this.email}}" target="_blank" -->
                            <div class="bg-base-100 p-16 box-shadow br-16 mt-16 mb-16 link">
                                <grid-row class="col-space-min align-item-center">
                                    <grid-col col="auto">
                                        <ng-icon iconClass="icon-email-us v-align-middle text-align-left" width="29"
                                            height="29"></ng-icon>
                                    </grid-col>
                                    <grid-col col="8">
                                        <span class="font-size-14px font-600 color-base-700 line-h-18">
                                            {{ "Fillform" | translate }}</span>
                                    </grid-col>
                                </grid-row>
                            </div>
                        </a>
                    </div>
                    <!-- <div class="mt-30">
                        <a style="text-decoration: none; cursor: pointer;" href="" target="_blank">
                            <div class="bg-base-100 p-16 box-shadow br-16 mt-16 mb-16 link">
                                <grid-row class="col-space-min align-item-center">
                                    <grid-col col="auto">
                                        <ng-icon iconClass="icon-rate-us v-align-middle text-align-left" width="29"
                                            height="29"></ng-icon>
                                    </grid-col>
                                    <grid-col col="8" mobile="auto">
                                        <span class="font-size-14px font-600 color-base-700 line-h-18">
                                            {{ "RateUs" | translate }}</span>
                                    </grid-col>
                                </grid-row>
                            </div>
                        </a>
                    </div> -->
                    <div class="mt-40 text-align-center">
                        <div class="font-size-14px color-base-600 font-400 line-h-22">
                            {{ "FollowUsOn" | translate}}
                        </div>
                        <grid-row class="col-space justify-content-center align-item-center mt-24">
                            <grid-col col="auto" *ngIf="this.LinkedInink  != null && this.LinkedInink  != ''">
                                <a href="{{this.LinkedInink}}" target="_blank">
                                    <ng-icon iconClass="icon-linkd-In bg-base-2200 br-100" width="40"
                                        height="40"></ng-icon>
                                </a>
                            </grid-col>
                            <grid-col col="auto" *ngIf="this.facebooklink  != null && this.facebooklink  != ''">
                                <a href="{{this.facebooklink}} " target="_blank">
                                    <ng-icon iconClass="icon-facebook bg-base-2200 br-100" width="40"
                                        height="40"></ng-icon>
                                </a>
                            </grid-col>
                            <grid-col col="auto" *ngIf="this.Instalink != null && this.Instalink != ''">
                                <a href="{{this.Instalink}}" target="_blank">
                                    <ng-icon iconClass="icon-insta bg-base-2200 br-100" width="40"
                                        height="40"></ng-icon>
                                </a>
                            </grid-col>
                            <grid-col col="auto" *ngIf="this.Youtubelink != null && this.Youtubelink != ''">
                                <a href="{{this.Youtubelink}}" target="_blank">
                                    <ng-icon iconClass="icon-you-tube bg-base-2200 br-100" width="40"
                                        height="40"></ng-icon>
                                </a>
                            </grid-col>
                        </grid-row>
                    </div>
                </grid-col>
            </grid-row>
    </div>
</div>



<modal modalID="1" [events]="modalObservable.asObservable()" [backdropDismiss]="true" modalDoneButtonText="LOGIN"
     (doneButton)="logIn()">
    <div class="text-align-center">
        <ng-icon iconClass="icon-mobile-otp-new" width="72" height="72"></ng-icon>
        <div class="mt-40 font-400 font-size-20px line-h-25 color-base-1300">
            {{ "Loginnow" | translate }}
        </div>
    </div>
</modal>